
























































































import { Component, Vue, Prop } from 'vue-property-decorator';


@Component
export default class BusinesCardForm extends Vue {
    @Prop() public businessCard!: BusinesCardForm;
    @Prop({default: false}) public disabled!: boolean;
}
